import React, { useEffect, useState } from "react";
import { api } from "../utils/api";

export default function StoresPage() {
  const [stores, setStores] = useState([]);
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(null);
  const [toast, setToast] = useState("");
  const [form, setForm] = useState({ name: "", zone: "", brand: "", city: "", phone: "", address: "", fastmag_code: "" });

  useEffect(() => { reload(); }, []);

  async function reload() {
    try { setStores(await api.getAllStores()); } catch (e) { console.error(e); }
  }

  function showToast(msg) { setToast(msg); setTimeout(() => setToast(""), 2500); }
  function setF(k, v) { setForm(f => ({ ...f, [k]: v })); }
  function resetForm() { setForm({ name: "", zone: "", brand: "", city: "", phone: "", address: "", fastmag_code: "" }); }

  async function save(e) {
    e.preventDefault();
    try {
      if (editing) {
        await api.updateStore(editing.id, form);
        showToast("Boutique mise a jour");
        setEditing(null);
      } else {
        await api.createStore(form);
        showToast("Boutique ajoutee");
        setAdding(false);
      }
      resetForm();
      reload();
    } catch (err) { showToast("Erreur: " + err.message); }
  }

  function startEdit(store) {
    setEditing(store);
    setForm({ name: store.name, zone: store.zone, brand: store.brand || "", city: store.city || "", phone: store.phone || "", address: store.address || "", fastmag_code: store.fastmag_code || "" });
    setAdding(false);
  }

  async function deleteStore(id) {
    if (!window.confirm("Desactiver cette boutique ?")) return;
    try { await api.deleteStore(id); showToast("Boutique desactivee"); reload(); }
    catch (err) { showToast("Erreur: " + err.message); }
  }

  const zones = [...new Set(stores.map(s => s.zone))].sort();
  const showForm = adding || editing;

  return (
    <div>
      <div className="page-header-row page-header">
        <div>
          <h1>Boutiques</h1>
          <p>Gerez les boutiques et zones pour les listes deroulantes</p>
        </div>
        {!showForm && (
          <button className="btn btn-primary" onClick={() => { setAdding(true); setEditing(null); resetForm(); }}>
            + Nouvelle boutique
          </button>
        )}
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: 20, borderLeft: "4px solid var(--accent)" }}>
          <div style={{ fontWeight: 700, marginBottom: 16, color: "var(--navy)" }}>
            {editing ? "Modifier la boutique" : "Nouvelle boutique"}
          </div>
          <form onSubmit={save}>
            <div className="form-grid">
              <div className="form-group">
                <label>Nom boutique *</label>
                <input value={form.name} onChange={e => setF("name", e.target.value)} placeholder="ex: Boutique Tunis Centre" required />
              </div>
              <div className="form-group">
                <label>Zone *</label>
                <input value={form.zone} onChange={e => setF("zone", e.target.value)} placeholder="ex: Grand Tunis" required list="zones-list" />
                <datalist id="zones-list">{zones.map(z => <option key={z} value={z} />)}</datalist>
              </div>
              <div className="form-group">
                <label>Marque / Enseigne</label>
                <input value={form.brand} onChange={e => setF("brand", e.target.value)} placeholder="ex: Luxolor" />
              </div>
              <div className="form-group">
                <label>Ville</label>
                <input value={form.city} onChange={e => setF("city", e.target.value)} placeholder="ex: Tunis" />
              </div>
              <div className="form-group">
                <label>Telephone</label>
                <input value={form.phone} onChange={e => setF("phone", e.target.value)} placeholder="+216 XX XXX XXX" />
              </div>
              <div className="form-group">
                <label>Code FastMag</label>
                <input value={form.fastmag_code} onChange={e => setF("fastmag_code", e.target.value)} placeholder="ex: MAG001" />
              </div>
              <div className="form-group full">
                <label>Adresse</label>
                <input value={form.address} onChange={e => setF("address", e.target.value)} placeholder="Adresse complete" />
              </div>
            </div>
            <div className="flex gap-2 mt-4">
              <button type="button" className="btn btn-outline" onClick={() => { setAdding(false); setEditing(null); resetForm(); }}>Annuler</button>
              <button type="submit" className="btn btn-primary">Enregistrer</button>
            </div>
          </form>
        </div>
      )}

      {zones.map(zone => (
        <div key={zone} style={{ marginBottom: 20 }}>
          <div style={{ fontWeight: 700, fontSize: 12, color: "var(--muted)", textTransform: "uppercase", letterSpacing: ".08em", marginBottom: 8, display: "flex", alignItems: "center", gap: 8 }}>
            <span>📍</span> {zone}
            <span style={{ background: "var(--bg)", borderRadius: 10, padding: "1px 8px", fontSize: 11 }}>
              {stores.filter(s => s.zone === zone).length}
            </span>
          </div>
          <div className="card" style={{ padding: 0, overflow: "hidden" }}>
            {stores.filter(s => s.zone === zone).map((store, i) => (
              <div key={store.id} className="admin-row" style={{ background: i % 2 === 0 ? "white" : "#fafbfd" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: 14, color: "var(--navy)" }}>{store.name}</div>
                  <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 2, display: "flex", gap: 12, flexWrap: "wrap" }}>
                    {store.city && <span>🏙️ {store.city}</span>}
                    {store.phone && <span>📞 {store.phone}</span>}
                    {store.fastmag_code && <span style={{ background: "#eff6ff", color: "var(--blue)", padding: "1px 8px", borderRadius: 8, fontSize: 11 }}>FastMag: {store.fastmag_code}</span>}
                  </div>
                </div>
                <div className="flex gap-2">
                  <button className="btn btn-outline btn-sm" onClick={() => startEdit(store)}>✏️</button>
                  <button className="btn btn-danger btn-sm" onClick={() => deleteStore(store.id)}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {stores.length === 0 && (
        <div className="empty-state">
          <div className="empty-state-icon">🏪</div>
          <h3>Aucune boutique</h3>
          <p>Ajoutez vos boutiques pour les listes deroulantes dans les visites</p>
        </div>
      )}

      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}
